import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters({ is_logged_in: "user/IS_LOGGED_IN" }),
  },
  methods: {
    updateLang: function (lang) {
      if (this.is_logged_in) this.$store.commit("user/SET", { lang: lang })
      this.$cookies.set("lang", lang)
      this.$cookies.set("switchLang", lang)
      this.$store.commit("SET_LANG", lang)
      this.$root.$i18n.locale = lang

      let path = this.$route.path.substr(1)
      path = path.substr(path.indexOf("/"))
      this.$router.push({
        path: "/" + lang + path,
        query: this.$route.query,
      })
    },
    patchLang: function (lang, email) {
      console.log({ lang })
      this.$axios
        .$patch("/auth/user/" + email + "/lang/", {
          lang: lang,
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.updateLang(lang)
        })
    },
  },
}
